

















































import { Component, Vue } from "vue-property-decorator";
import { confirmList } from "./confirm";
import { commodityShelfDown, commodityResume, shield } from "@/req/shopManage";
@Component({
  components: {},
})
export default class Logout extends Vue {
  public list = confirmList;
  public type: any = 0;
  public state: any = "";
  public ids: any = "";
  public uid: any = "";
  public data: any = [];
  public modalShow = false;
  public show(type, state, ids, uid, data) {
    this.type = type;
    this.state = state;
    this.ids = "";
    this.uid = "";
    this.ids = ids;
    this.uid = uid;
    this.data = [];
    this.data = data;
    this.modalShow = true;
  }
  // state 1 商品下架
  // state 2 恢复商品上架
  // state 3 屏蔽商品
  // state 4 取消屏蔽商品
  // state 5 商品还价中
  public async save() {
    if (this.state == 1 || this.state == 2 || this.state == 5) {
      const obj = {
        token: this.$fn.cookies.getToken("token"),
        commodity_id: this.ids,
      };
      const res =
        this.state == 1 || this.state == 5
          ? await commodityShelfDown(obj)
          : await commodityResume(obj);
      if (res.code == 0) {
        this.$Message.success(res.msg);
      }
    }
    if (this.state == 3 || this.state == 4) {
      const obj = {
        token: this.$fn.cookies.getToken("token"),
        commodity_id: this.ids,
        type: this.state == 3 ? 1 : 2,
      };
      const res = await shield(obj);
      if (res.code == 0) {
        this.$Message.success(res.msg);
      }
    }
    this.$emit("getList");
    this.modalShow = false;
  }
}
